export default function initHeroSelect() {
  const heroSelects = Array.from(document.querySelectorAll('[data-hero-select]'));
  if (!heroSelects.length) return;

  const heroSection = document.getElementById('frontpage-hero');

  const closeAll = () => {
    heroSelects.forEach((wrapper) => {
      const dropdown = wrapper.querySelector('[data-hero-select-dropdown]');
      const trigger  = wrapper.querySelector('[data-hero-select-trigger]');
      wrapper.classList.remove('is-open');
      if (dropdown) dropdown.classList.remove('is-open');
      if (trigger)  trigger.setAttribute('aria-expanded', 'false');
    });
    if (heroSection) heroSection.classList.remove('hero-dropdown-open');
  };

  heroSelects.forEach((wrapper) => {
    const native   = wrapper.querySelector('[data-hero-select-native]');
    const trigger  = wrapper.querySelector('[data-hero-select-trigger]');
    const dropdown = wrapper.querySelector('[data-hero-select-dropdown]');
    const label    = wrapper.querySelector('[data-hero-select-label]');
    const options  = Array.from(wrapper.querySelectorAll('[data-hero-select-option]'));
    if (!native || !trigger || !dropdown || !label) return;

    const sync = () => {
      const selected = Array.from(native.options).find((o) => o.value === native.value);
      label.textContent = selected ? selected.textContent.trim() : label.textContent;
      options.forEach((opt) => opt.classList.toggle('is-active', (opt.dataset.value || '') === native.value));
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');
      closeAll();
      if (!isOpen) {
        wrapper.classList.add('is-open');
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (heroSection) heroSection.classList.add('hero-dropdown-open');
      }
    });

    options.forEach((opt) => {
      opt.addEventListener('click', () => {
        native.value = opt.dataset.value || '';
        native.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        closeAll();
      });
    });

    native.addEventListener('change', sync);
    sync();
  });

  document.addEventListener('click', (e) => { if (!e.target.closest('[data-hero-select]')) closeAll(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
}
